const eventslug = "HOME_EVENT";

const eventSpeakerRoleSlug = "EVENT_SPEAKER";

const eventMemberRoleSlug = "EVENT_MEMBER";

const placeholderCount = [1, 2, 3, 4, 5, 6];

const ecosystemSlug = "MADRID_NETWORK";

export {
  eventslug,
  eventSpeakerRoleSlug,
  eventMemberRoleSlug,
  placeholderCount,
  ecosystemSlug,
};
